import { Component, Input, OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { TaqmanProductInterface } from '@app/models/interfaces/taqman-product.interface';
import { StoreService } from '@app/services/store.service';
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap/popover/popover";
import { Subscription } from 'rxjs';


@Component({
    selector: 'tf-result-checkbox',
    templateUrl: './result-checkbox.component.html',
    styleUrls: ['./result-checkbox.component.scss']
})
export class TfResultCheckboxComponent implements OnInit, OnDestroy {

    @Input() product: TaqmanProductInterface = null;
    checked: boolean = false;

    private subscriptions: Subscription = new Subscription();

    constructor(private storeService: StoreService) {}

    ngOnInit(): void {
        const resultsSubscription = this.storeService.selectedResults$.subscribe((results) => {
            if (results === null) {
                return;
            }

            const products = results.products || [];
            this.checked = products.includes(this.product);
        });

        this.subscriptions.add(resultsSubscription);

    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    popoverWarningTemplate(ref1, ref2): TemplateRef<any> {
        return this.storeService.getSelectedProductsCount() >= 3 ? ref2 : ref1;
    }

    handleCheckChange(event: Event | any, popover: NgbPopover) {
        if (event.checked) {
            this.storeService.addSelectedProduct(this.product);
            if (popover) {
                if (this.storeService.shouldDisplayWarning() || this.storeService.shouldDisplayFirstWarning()) {
                    popover.open();
                }
            }

        } else {
            this.storeService.removeSelectedProduct(this.product);
        }
    }
}
